import React, { useState, useEffect} from "react";
import "./App.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "../src/styles/mainStyle.scss";
import "../src/styles/outsideStyles.scss";
import BasicModal from "./views/core/BaseComponents/Modal";
import { ToastContainer } from 'react-toastify';

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if(location?.pathname === "/" && token){
      navigate("/hms/ConfigurationNewHotel")
    }else if(location?.pathname === "/"){
      navigate("/login")
    }
  }, [location]);

  const [errorFlag401Popup, setErrorFlag401Popup] = useState(false);
  const [errorFlag500Popup, setErrorFlag500Popup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  window.addEventListener("401_Error", (e) => {
    setErrorFlag401Popup(true);
    setPopupMessage(e.detail);
  });
  window.addEventListener("500_error", (e) => {
    setErrorFlag500Popup(true);
    setPopupMessage(e.detail);
  });

  const popup401CloseHandler = () => {
    setErrorFlag401Popup(false);
    localStorage.clear();
    navigate("/login");
  };

  const popup500CloseHandler = () => {
    setErrorFlag500Popup(false);
  };

  return (
    <div className="main">
      <Outlet />
      <ToastContainer className='w-25'/>
      <BasicModal
        popupOpen={errorFlag401Popup}
        bodyMessage={popupMessage}
        logo = {"/Images/Rejected.png"}
        footer={{
          secondaryButton: {
            action: popup401CloseHandler,
            buttonName: "OK",
          },
        }}
      />
      <BasicModal
        popupOpen={errorFlag500Popup}
        bodyMessage={popupMessage}
        logo = {"/Images/Rejected.png"}
        footer={{
          secondaryButton: {
            action: popup500CloseHandler,
            buttonName: "OK",
          },
        }}
      />
    </div>
  );
}

export default App;
